import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LoggerService } from '../services/logger.service';

/**
 * Global error handler for catching and logging unhandled errors
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private logger = inject(LoggerService);

  handleError(error: Error | unknown): void {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
    const errorStack = error instanceof Error ? error.stack : undefined;

    // Log the error
    this.logger.error('Unhandled error:', { message: errorMessage, stack: errorStack });

    // In production, you might want to send this to a monitoring service
    // Example: this.monitoringService.logError(error);

    // Re-throw in development for debugging
    if (!this.isProduction()) {
      console.error('GlobalErrorHandler caught:', error);
    }
  }

  private isProduction(): boolean {
    return typeof window !== 'undefined' && 
           (window as any)['__PRODUCTION__'] === true;
  }
}
